<template>
	<div :class="['payments-page', {'col-xs-12 pb-5': isInstallmentPage}]">
		<div>
			<h2 class="level-one-heading mb-5">Mina delbetalningar</h2>
			<hr>
			<toggle-button
				v-for="tab in tabs"
				v-model="selectedTab"
				:activeValue="tab"
				:text="tab.name "
				:key="tab.id"
				@click="updateUrlQuery"
				sticky
			/>
			<div v-if="bankIdUser" class="row">
				<div class="col-xs-12">
					<span class="mt-5 col-xs-7 pl-0">{{ bankIdUser }}</span>
					<text-button
						class="pull-right mt-4 col-md-2"
						text="Logga ut"
						@click="logout"
					/>
				</div>
			</div>
			<img v-if="! bankidConfirmed" class="pay-img" :src="convertToCdnUrl('/images/620516-infodelbetalning2022?raw')" alt="Webhallen delbetalning" />
		</div>
		<div v-if="loading">
			<loading-spinner class="mb-5" />
		</div>
		<div v-else class="pt-4">
			<questions-tab v-if="selectedTab === tabs.questions"/>
			<wh-bankid v-else-if="! bankidConfirmed"
				:userSsn="ssn"
			/>
			<payments-tab v-else-if="selectedTab === tabs.payments"
				:ssn="ssn"
				:sessionId="sessionId"
				:paymentInfo="paymentInfo"
				:sessionToken="sessionToken"
				:invoicingEmail="invoicingEmail"
			/>
			<account-tab v-else-if="selectedTab === tabs.account"
				:ssn="ssn"
				:user="user"
				:sessionId="sessionId"
				:sessionToken="sessionToken"
				:finalInvoice="finalInvoice"
				:invoicingEmail="invoicingEmail"
				:canExtendDueDate="canExtendDueDate"
				:isDueDateExtended="isDueDateExtended"
				:isPaid="paymentInfo.isPaid"
				:invoiceDistributionByEmail="invoiceDistributionByEmail"
			/>
		</div>
	</div>
</template>

<script>
import alert from 'alert';
import bus from 'eventbus';
import router from 'router';
import { mapState } from 'vuex';
import { convertToCdnUrl  } from 'utils';

const questionsTab = () => import('./questions-tab');
const accountTab = () => import('./account-tab');
const paymentsTab = () => import('./payments-tab');
const whBankid = () => import('./wh-bankid');




export default {
	data () {
		return {
			bankidConfirmed: false,
			ssn: null,
			selectedTab: null,
			loading: false,
			sessionToken: null,
			sessionId: null,
			bankIdUser: null,
			canExtendDueDate: false,
			isDueDateExtended: false,
			invoiceDistributionByEmail: false,
			paymentInfo: {
				amount: null,
				dueDate: null,
				ocr: null,
				paidAmount: null,
				currentDebt: 0,
			},
			finalInvoice: {},
			invoicingEmail: '',
			tabs: {
				payments: {
					id: 'payments',
					name: 'Betalningar',
				},
				account: {
					id: 'account',
					name: 'Mitt konto',
				},
				questions: {
					id: 'questions',
					name: 'Frågor & svar',
				},
			},
		};
	},
	mounted() {
		this.checkCookie();

		// Parse the url query (sets the selected tab).
		this.parseUrlQuery();

		if (! this.selectedTab) {
			this.selectedTab = this.tabs.payments;
		}

		if (this.user.ssn) {
			this.ssn = this.user.ssn;
		}
		bus.$on('bankid-confirmed', this.setBankdidConfirmation);
		bus.$on('delayed-payment', () => {
			this.canExtendDueDate = false;
			this.isDueDateExtended = true;
		});
		bus.$on('invoicing-email-updated', email => {
			this.invoicingEmail = email;
		});
		bus.$on('update-account-data', this.getAccountdata);
		bus.$on('payments-logout', this.logout);
	},
	beforeDestroy () {
		bus.$off('bankid-confirmed', this.setBankdidConfirmation);
	},
	methods: {
		convertToCdnUrl,
		logout () {
			this.loading = true;
			this.bankIdUser = null;
			waja.get('bankid/logout')
				.on('success', res => {
					this.checkCookie();
					setTimeout(() => { this.loading = false; }, 1500);
				}).go();
		},
		checkCookie () {
			waja.get('check-bankid-auth')
				.on('success', res => {
					this.bankidConfirmed = res.data.status;
					if (res.data.name) {
						this.bankIdUser = res.data.name;
					}
				}).on('error', res => {
					this.bankidConfirmed = false;
					alert('Något gick fel!');
				}).go();
		},
		setBankdidConfirmation (confirmed, status = null) {
			this.bankidConfirmed = confirmed;
			if (! status) {
				this.bankIdUser = null;
				this.sessionToken = null;
				this.sessionId = null;
			} else {
				this.bankIdUser = status.user.name;
				this.ssn = status.user.personalNumber;
				this.sessionToken = status.token;
				this.sessionId = status.id;
			}
		},
		updateUrlQuery () {
			const urlQuery = {
				tab: this.selectedTab.id,
			};

			router.setQuery(urlQuery);
		},
		parseUrlQuery () {
			const query = this.$route.query;
			if (query.tab) {
				this.selectedTab = this.tabs[query.tab];
			}
		},
		getAccountdata () {
			waja.get('whfinancing/account')
				.on('success', res => {
					const data = res.data;
					if (data.hasAccount) {
						const transactions = [];
						data.events.forEach(e => {
							transactions.push({
								description: e.type,
								amount: e.amount.total,
								reference: e.reference,
								transdate: new Date(e.dateTime),
							});
						});
						this.finalInvoice.amount = data.finalPayment.amount;
						this.finalInvoice.ocr = data.finalPayment.ocr;

						this.paymentInfo = {
							amount: data.currentInvoice.data ? data.currentInvoice.data.amount.total : null,
							dueDate: data.currentInvoice.data ? new Date(data.currentInvoice.data.dueDate) : null,
							ocr: data.currentInvoice.data ? data.currentInvoice.data.ocr : null,
							paidAmount: data.currentInvoice.data ? data.currentInvoice.data.paidAmount : null,
							currentDebt: data.currentDebt,
							isPaid: data.currentInvoice.data ? data.currentInvoice.data.isPaid : null,
							transactions: transactions,
							type: data.currentInvoice.status,
						};
						this.invoicingEmail = data.invoicing.email;
						this.invoiceDistributionByEmail = data.invoiceDistributionByEmail;

						this.canExtendDueDate = data.currentInvoice.canExtendDueDate;
						this.isDueDateExtended = data.currentInvoice.isDueDateExtended;
					} else {
						this.nullAccount();
					}
					this.loading = false;
				}).on('error', res => {
					this.nullAccount();
					if (res.status == 401) {
						alert('Vänligen logga in igen');
						bus.$emit('payments-logout');
					}
					this.loading = false;
				}).go();
		},
		nullAccount () {
			this.finalInvoice.amount = null;
			this.finalInvoice.ocr = null;

			this.paymentInfo = {
				amount: null,
				dueDate: null,
				ocr: null,
				paidAmount: null,
				currentDebt: null,
				isPaid: null,
				latestEvents: null,
			};
			this.invoicingEmail = null;
			this.invoiceDistributionByEmail = false;

			this.canExtendDueDate = null;
			this.isDueDateExtended = null;
		},
	},
	computed: {
		isInstallmentPage () {
			return this.$route.name == 'delbetalning';
		},
		...mapState({
			user: state => state.user,
		}),
	},
	watch: {
		user () {
			if (this.user.ssn) {
				this.ssn = this.user.ssn;
			}
		},
		bankidConfirmed (to, frm) {
			if (to == true) {
				this.loading = true;
				this.getAccountdata();
			}
		},
	},
	components: {
		whBankid,
		paymentsTab,
		accountTab,
		questionsTab,
	},
};
</script>
